export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const RESET_SUPPLIER = 'RESET_SUPPLIER';